
import { mapState, mapActions } from "vuex";
import noDataLabel from "../common/no-data-label.vue";
export default {
  components: { noDataLabel },
  data() {
    return {
      series: [],
      chartOptions: {
        labels: ["Online", "Offline"],
        colors: ["#28D484", "#FF4560"],
        chart: {
          type: "pie",
          width: "158px",
          height: "158px"
        },
        legend: {
          position: "bottom",
          horizontalAlign: "left",
          fontSize: "10px",
          height: "25"
        },

        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            const hours = opts.w.config.series[opts.seriesIndex];
            return hours.toFixed(2) + " Hours";
          },
          style: {
            fontSize: "12px",
            textTransform: "capitalize"
          }
        }
      }
    };
  },
  computed: {
    ...mapState("report", ["storeAvailability", "storeAvailabilityLoading"])
  },
  mounted() {
    this.fetchStoreAvailability();
  },
  methods: {
    ...mapActions("report", ["getStoreAvailability"]),
    async fetchStoreAvailability(backgroundLoad = true) {
      await this.getStoreAvailability({
        backgroundLoad
      });
      this.calculateAvailability();
    },
    calculateAvailability() {
      let onlineMinutes = 0;
      const numberOfDays = this.storeAvailability.length;
      this.storeAvailability.forEach((day) => {
        day.data.forEach((period) => {
          const openTime = new Date(day.date + period.open).getTime();
          const closeTime = new Date(day.date + period.close).getTime();
          const durationMinutes = (closeTime - openTime) / 1000 / 60;

          onlineMinutes += durationMinutes;
        });
      });

      const totalMinutes = this.storeAvailability.length * 24 * 60;
      const offlineMinutes = totalMinutes - onlineMinutes;

      const onlineHours = Number(
        this.roundNumberWithTwoDecimal(onlineMinutes / numberOfDays / 60)
      );
      const offlineHours = Number(
        this.roundNumberWithTwoDecimal(offlineMinutes / numberOfDays / 60)
      );

      if (isNaN(onlineHours) || isNaN(offlineHours)) {
        this.series = [];
        return;
      }
      this.series = [onlineHours, offlineHours];
    }
  }
};
